export default "__VITE_ASSET__DSyqXhfk__"